// @ts-check

import { generateMock } from '@anatine/zod-mock';
import { faker } from '@faker-js/faker';

import { creatingPartySchema } from '@/data/schema/parties';

/** @typedef {import('@/data/schema/parties').TNewOrSavedParty} TUpdateParty */
/** @typedef {import('@/data/schema/parties').TCreatingParty} TCreatingParty */

/**
 * @param {Partial<TCreatingParty>} [properties]
 * @returns {TCreatingParty}
 */
export function createParty(properties = {}) {
  const firstName = faker.person.firstName();
  const lastName = faker.person.lastName();
  const title = `${firstName} ${lastName}`;
  const email = faker.internet.email({ firstName, lastName });

  const party = generateMock(creatingPartySchema, {
    stringMap: {
      fingerprint: () => faker.string.uuid(),
      title: () => title,
      email: () => email,
      role: () => 'signer',
    },
  });

  return { ...party, ...properties };
}

/**
 * @param {number} count
 * @param {Partial<TCreatingParty>[]} [properties]
 */
export function createParties(count, properties = []) {
  return Array.from(Array(count), (_, index) => createParty(properties[index]));
}

/**
 * @param {Partial<TUpdateParty>} [properties]
 * @returns {TUpdateParty}
 */
export function createNewParty(properties = {}) {
  return {
    base: false,
    title: '',
    email: '',
    password: undefined,
    message: undefined,
    order: 0,
    role: 'signer',
    role_ids: [],
    ...properties,
  };
}

/**
 * @param {number} count
 * @param {Partial<TUpdateParty>[]} [properties]
 */
export function createNewParties(count, properties = []) {
  if (count >= 1) {
    return Array.from(Array(count), (_, index) =>
      createNewParty(properties[index]));
  }

  return [];
}
